import emptySplitApi from "../utils/rtk";
import { User } from "../types/User";
import { CommonBody } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  data: any;
  status: number;
  message: string;
};

export const onBoardingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    logIn: builder.mutation<CommonResponseType & { data: User }, CommonBody>({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    getProfile: builder.query<CommonResponseType & { data: User }, void>({
      query: () => ({
        url: END_POINTS.getProfile,
        method: "GET",
      }),
    }),

    forgotPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: "POST",
        body,
      }),
    }),
    resendOtp: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.resendOtp,
        method: "POST",
        body,
      }),
    }),
    postVerifyOtp: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    updateProfile: builder.mutation<
      CommonResponseType & { data: User },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: "PUT",
        body,
      }),
    }),
    logoutUser: builder.mutation<CommonResponseType & { data: any }, void>({
      query: () => ({
        url: END_POINTS.logout,
        method: "POST",
      }),
    }),
    changePassword: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "POST",
        body,
      }),
    }),

    faceCheckImage: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.faceCheck,
        method: "POST",
        body,
      }),
    }),
    passportCheckImage: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.passportCheck,
        method: "POST",
        body,
      }),
    }),
    documentCheck: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.documentCheck,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLogInMutation,
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
  useResendOtpMutation,
  useResetPasswordMutation,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useChangePasswordMutation,
  useLogoutUserMutation,
  useFaceCheckImageMutation,
  usePassportCheckImageMutation,
  useDocumentCheckMutation,
} = onBoardingApi;
